module.exports = __webpack_public_path__ + "static/img/guide_2_0.778107b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_2_0.jpg
// module id = lec8
// module chunks = 1